// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import type { VMessageTemplateContext } from '../../index.ts';

import { AssertError } from '@atlassian/vindicated';
export function assert(value: any): VMessageTemplateContext {
    const result = validate(value);
    if (!result.success) {
        const firstError = result.errors[0];
        throw new AssertError('assert', firstError.path, firstError.expected, firstError.value);
    }
    return result.data as VMessageTemplateContext;
}
export { assert as assertMessageTemplateContext };


export function is(value: any): value is VMessageTemplateContext {
	const result = validate(value);
    return result.success;
}
export { is as isMessageTemplateContext };


import type { ValidationResult } from '@atlassian/vindicated';
export function validate(value: any): ValidationResult<VMessageTemplateContext> {
    const errors = [];
    const originalData = value;
    
	if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        errors.push({ path: 'value', expected: 'MessageTemplateContext', value: value });
    } else {
			if (!('message' in value)) {
				errors.push({ path: 'value["message"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["message"] !== 'string') errors.push({ path: 'value["message"]', expected: 'string', value: value["message"] });
			}
			if ('link' in value && value['link'] !== undefined) {
				
	if (typeof value["link"] !== 'object' || value["link"] === null || Array.isArray(value["link"])) {
        errors.push({ path: 'value["link"]', expected: 'object', value: value["link"] });
    } else {
			if (!('href' in value["link"])) {
				errors.push({ path: 'value["link"]["href"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["link"]["href"] !== 'string') errors.push({ path: 'value["link"]["href"]', expected: 'string', value: value["link"]["href"] });
			}
			if (!('text' in value["link"])) {
				errors.push({ path: 'value["link"]["text"]', expected: 'string', value: undefined });
			} else {
				if (typeof value["link"]["text"] !== 'string') errors.push({ path: 'value["link"]["text"]', expected: 'string', value: value["link"]["text"] });
			}
    }
			}
    }
    if (errors.length === 0) return { success: true, data: value };
    return { success: false, data: originalData, errors: errors };
}
export { validate as validateMessageTemplateContext };
